import { defineStore } from 'pinia'

import { CATEGORY_TITLE_KEYS } from '@/constants'

interface State {
  categories: Array<any>
}

export const useCategoryStore = defineStore('category', {
  // convert to a function
  state: (): State => ({
    categories: [],
  }),

  getters: {
    getCategoryTitle: (state) => {
      return (categoryId: number, languageKey: string) => {
        const category: Record<string, any> = state.categories.find(
          (item) => item.id === categoryId
        )

        const key: string = CATEGORY_TITLE_KEYS[languageKey]

        return category[key]
      }
    },

    getSubCategoryTitle: (state) => {
      return (
        categoryId: number,
        subCategoryId: number,
        languageKey: string
      ) => {
        const category: Record<string, any> = state.categories.find(
          (item) => item.id === categoryId
        )

        const subCategory: Record<string, any> = category.sub_categories.find(
          (subItem: Record<string, any>) => subItem.id === subCategoryId
        )

        const key: string = CATEGORY_TITLE_KEYS[languageKey]

        return subCategory[key]
      }
    },
  },

  actions: {
    setCategories(categories: any[]) {
      this.categories = categories
    },
  },
})
